import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import Home_Post from "./Home_Post.jsx";
import DishSuggestion from "./DishSuggestion.jsx";
import dishesData from '../assets/dishes2.json';
import { Link } from "react-router-dom";
import Trophy from "../assets/trophy.png";
import { RiDropdownList } from "react-icons/ri";
import "../styles/Homepage.css";
import { json } from "react-router-dom";

/*
  The PostingList is going to load all the posts in the system. This model won't work well if you have a lot of 
  posts - you would want to find a way to limit the posts shown.
*/
const HomePostingList = ({ refresh, posts, error, isLoaded, type, loadPosts, loadFollowedPosts, postList, suggestedDishes,apost }) => {
  const [userToken, setUserToken] = useState("");
  const [TopDishes, setTopDishes]=useState([]);
  const [isRankboardLoading, setIsRankboardLoading] = useState(true);
  const blockedContent = JSON.parse(sessionStorage.getItem("blockedPosts"));
  const accountJSON = sessionStorage.getItem("accountJSON");
  const [blockingList, setBlockingList] = useState([]);
  const [fetched, setFetched] = useState(false);
  const userId = sessionStorage.getItem("user");


  useLayoutEffect(() => {
    setUserToken(sessionStorage.getItem("token"));
  }, []);
  useEffect(() => {
  
    if (!isLoaded || !apost || apost.length === 0 || apost.length<0) return; // Only run once posts are loaded

    const avgList = dishesData.map((dish) => {
      const dishId = dish.id.toString();
      const dishName = dish.title;
      const dishedPost = apost.filter((post) => post.attributes?.dishID === dishId);
      const totalRating = dishedPost.reduce((sum, post) => sum + post.attributes.overallRating, 0);
      const average = dishedPost.length > 0 ? totalRating / dishedPost.length : 0;

      return { dishId, dishName, average};
    });

    const sorted = avgList
      .sort((a, b) => b.average - a.average)
      .slice(0, 10) // Get the top 10 dishes
     
      setTopDishes(sorted);
      setIsRankboardLoading(false);
    
  }, [apost, isLoaded]); 
  const fetchUserData = async () => {

    try {
      // Fetch user details
      if (userId != null) {
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${userToken}`,
          },
        }
      ); 

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("Failed to fetch user data. Status:", response.status, "Response:", errorData);
        throw new Error(errorData.message || `Failed to fetch user data (${response.status})`);
      }

      const result = await response.json();
      // console.log("RESULTS!");
      // console.log(result);
      sessionStorage.setItem("accountJSON",JSON.stringify(result));
      const newList = [];
      for (let entry in result.attributes.blockedPosts){
        blockingList.push(parseInt(entry));
      }
      // console.log("This is the new List!")
      // console.log(blockingList);
      setFetched(true);
    }
    }
    catch (err) {
      return;
    }
  }
 
  useLayoutEffect(() => {
    // console.log("HELLO!!!");
    fetchUserData();
    // console.log(sessionStorage.getItem("accountJSON"));
  },[]);

  if (!isLoaded) {
    return <div className="loading-message">Loading posts...</div>;
  } else if (error) {
    return <div className="error-message">Error loading posts: {error.message}</div>;
  } else if (posts && posts.length > 0) {
    return (
      <div className="mainspace">
      <div className="posts">
        {/* {console.log("FINISHED LOADING, HERE IS THE BLOCKING LIST")} */}
        {/* {console.log(blockingList)} */}
      {userId != null && (posts.filter((post) => !blockingList.includes(post.id)).map((post) => (
        <Home_Post key={post.id} post={post} type={type} loadPosts={loadPosts}/>)
      ))}
      {userId == null && (posts.map((post) => (
        <Home_Post key={post.id} post={post} type={type} loadPosts={loadPosts}/>)
      ))}
     
 </div>
      {/* Display Top Dishes after posts */}
      <div className="boards">
          <div className="rankb">
            <b>Top Dishes</b>
            <img src={Trophy} className="trophy" alt="Trophy" />
            <div className="pad">
              <ol className="list">
                {isRankboardLoading ? (
                  <div className="loading-message">Loading Top Dishes...</div>
                ) : TopDishes.length > 0 ? (
                  TopDishes.map((dish) => (
                    <li key={dish.dishId}>
                      <Link className="boardl" to={`/dish/${dish.dishId}`}>
                        {dish.dishName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <div className="loading-message">Calculating Top Dishes...</div>
                )}
              </ol>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    // No posts found - show message and dish suggestions if available
    return (
      <div className="no-results-container">
        <div className="no-posts-container">
          <div className="no-posts-message">
            <h3>No Posts Found</h3>
            <p>Try adjusting your filters or check back later for new content.</p>
          </div>
        </div>
        
        {/* Display dish suggestions if available */}
        {suggestedDishes && suggestedDishes.length > 0 && (
          <DishSuggestion dishes={suggestedDishes} />
        )}
      </div>
    );
  }
};

export default HomePostingList;
